<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilterDateRange
        ref="dateRangeFilter"
        v-on:filter-data-change="onFilterDateChange" />

      <button v-show="showExportCSV" v-on:click="onCSVButtonClick" type="button" class="btn btn-warning">
        Export CSV
      </button>

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"/>

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');
var moment = require('moment');

let PARAM = [
  {
    key: 'parkinglicense',
    text: 'A/C NO',
  },
  {
    key: 'customer',
    text: 'Customer Name',
  },
  {
    key: 'season',
    text: 'Product Name',
  },
  {
    key: 'type',
    text: 'Type',
  },
  {
    key: 'reserve_passes',
    text: 'RESERVED<br>Passes',
  },
  {
    key: 'reserve_rate',
    text: 'RESERVED<br>Rate',
  },
  {
    key: 'reserve_value',
    text: 'RESERVED<br>Value',
  },
  {
    key: 'non_reserve_passes',
    text: 'NON-RESERVED<br>Passes',
  },
  {
    key: 'non_reserve_rate',
    text: 'NON-RESERVED<br>Rate',
  },
  {
    key: 'non_reserve_value',
    text: 'NON-RESERVED<br>Value',
  },
  {
    key: 'tandem_reserve_passes',
    text: 'TANDEM-RESERVED<br>Passes',
  },
  {
    key: 'tandem_reserve_rate',
    text: 'TANDEM-RESERVED<br>Rate',
  },
  {
    key: 'tandem_reserve_value',
    text: 'TANDEM-RESERVED<br>Value',
  },
  {
    key: 'motorbike_passes',
    text: 'MOTORBIKE<br>Passes',
  },
  {
    key: 'motorbike_rate',
    text: 'MOTORBIKE<br>Rate',
  },
  {
    key: 'motorbike_value',
    text: 'MOTORBIKE<br>Value',
  },
  {
    key: 'total_passes',
    text: 'TOTAL<br>Passes',
  },
  {
    key: 'total_value',
    text: 'TOTAL<br>Value',
  },
  {
    key: 'remark',
    text: 'REMARKS',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageReportCustomerMovement",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
    AppFilterDateRange,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Report' },
        { name: 'Customer Movement' },
      ],

      PARAM,
      PARAM_MAP,

      pageStaff: [],
      pagePaymentMethod: [],
      pageCarpark: null,
      pageCustomer: null,
      pageBill: null,
      pageSeasonFees: {},
      pageReport: null,

      showExportCSV: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['dateRangeFilter'].filterDateStart = moment().startOf('month');
    this.$refs['dateRangeFilter'].filterDateEnd = moment().endOf('month');
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.loadSeason();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadSeason() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading product data...');

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/season/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.loadLicense();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
        })
    },
    loadLicense() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading license data...');

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/licenses/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageLicense = response.data;
            this.loadLeaseActive();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
        })
    },
    loadLeaseActive() {
      let startDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateStart);
      let endDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateEnd);

      let feedbackItem = 'report data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/leases?startDate=' + startDate + '&stopDate=' + endDate + '&current=1',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageReport = response.data;
            this.processReport();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    // loadLeaseAll() {
    //   let startDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateStart);
    //   let endDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateEnd);

    //   let feedbackItem = 'report data';
    //   this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
    //   this.$http
    //     .get(
    //       helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/leases?startDate=' + startDate + '&stopDate=' + endDate + '&current=1',
    //       helper.createAxiosConfig()
    //     )
    //     .then(response => {
    //       if(response.data && response.data.length > 0) {
    //         this.$refs['pageFeedback'].setFeedbackMessage();
    //         this.pageReport.concat(reponse.data.filter(k => k.status !== 'Active'));
    //       } else {
    //         this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
    //       }
    //     })
    //     .catch(error => {
    //       this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
    //     })
    // },

    async processReport() {
      let leaseGroup = {};

      for(let index in this.pageReport) {
        let k = this.pageReport[index];

        // TODO kw1 risk duplicate lease - e.g. map back current month active + terminate lease then display once?
        let temp = leaseGroup[k.customerID + ' ' + k.seasonID + ' ' + k.status] = leaseGroup[k.customerID + ' ' + k.seasonID] || {
          reserve_passes: 0,
          non_reserve_passes: 0,
          tandem_reserve_passes: 0,
          motorbike_passes: 0,
          total_passes: 0,
          total_value: 0,
        };

        let license = this.pageLicense.find(j => helper.compareID(j.id, k['licenseID']));

        temp['parkinglicense'] = helper.plFormPLNum(license['licenseOperatorNum'], license['carparkID']);
        temp['customer'] = k['customerName'];
        temp['season'] = k['seasonName'];
        temp['seasonID'] = k['seasonID'];
        temp['status'] = k['status'];

        let season = this.pageSeason.find(j => helper.compareID(j.id, k['seasonID']));
        if(!season) {
          return;
        }

        let seasonFees = this.pageSeasonFees[k['seasonID']];
        if(!seasonFees) {
          await this.$http
            .get(
              helper.SERVER_URL + '/api2/season/' + k['seasonID'] + '/currentSeasonFees/',
              helper.createAxiosConfig()
            )
            .then(response => {
              let resultMeta = helper.processAxiosResponse(this, response);
              if(response.data && response.data.length > 0) {
                this.$refs['pageFeedback'].setFeedbackMessage();
                this.pageSeasonFees[k['seasonID']] = response.data[0];
              } else {
                this.$refs['pageFeedback'].setFeedbackError('No product data available.');
              }
            })
            .catch(error => {
              this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
            })
        }

        temp['type'] = season.isTenant ? 'T' : 'NT';
        // { 2 : 'Reserved' },
        // { 3 : 'Tandem-Reserved' },
        // { 1 : 'Non-Reserved' },
        // { 4 : 'Motorcycle' },
        // TODO kw1 calculate those with passcard or just lease active
        switch(k['bayType']) {
          case 1:
            temp['non_reserve_passes']++;
            break;
          case 2:
            temp['reserve_passes']++;
            break;
          case 3:
            temp['tandem_reserve_passes']++;
            break;
          case 4:
            temp['motorcycle_passes']++;
            break;
        }
        temp['total_passes']++;
      }

      let temp = [];
      let totalTemp = {
        reserve_passes: 0,
        reserve_rate: 0,
        reserve_value: 0,
        non_reserve_passes: 0,
        non_reserve_rate: 0,
        non_reserve_value: 0,
        tandem_reserve_passes: 0,
        tandem_reserve_rate: 0,
        tandem_reserve_value: 0,
        motorbike_passes: 0,
        motorcycle_rate: 0,
        motorcycle_value: 0,
        total_passes: 0,
        total_value: 0,
      };

      for(let temp1 in leaseGroup) {
        let temp2 = leaseGroup[temp1];

        let seasonFees = this.pageSeasonFees[temp2['seasonID']];
        if(temp2['non_reserve_passes']) {
          temp2['non_reserve_rate'] = helper.formatMoney(seasonFees['monthly']);
          temp2['non_reserve_value'] = temp2['non_reserve_passes'] * seasonFees['monthly'];
          temp2['total_value'] += temp2['non_reserve_value'];

          totalTemp['non_reserve_passes'] += temp2['non_reserve_passes'];
          totalTemp['non_reserve_rate'] += seasonFees['monthly'];
          totalTemp['non_reserve_value'] += temp2['non_reserve_value'];
          totalTemp['total_passes'] += temp2['non_reserve_passes'];
          totalTemp['total_value'] += temp2['non_reserve_value'];

          temp2['non_reserve_value'] = helper.formatMoney(temp2['non_reserve_value']);
        }
        if(temp2['reserve_passes']) {
          temp2['reserve_rate'] = helper.formatMoney(seasonFees['monthly']);
          temp2['reserve_value'] = temp2['reserve_passes'] * seasonFees['monthly'];
          temp2['total_value'] += temp2['reserve_value'];

          totalTemp['reserve_passes'] += temp2['reserve_passes'];
          totalTemp['reserve_rate'] += seasonFees['monthly'];
          totalTemp['reserve_value'] += temp2['reserve_value'];
          totalTemp['total_passes'] += temp2['reserve_passes'];
          totalTemp['total_value'] += temp2['reserve_value'];
          
          temp2['reserve_value'] = helper.formatMoney(temp2['reserve_value']);
        }
        if(temp2['tandem_reserve_passes']) {
          temp2['tandem_reserve_rate'] = helper.formatMoney(seasonFees['monthly']);
          temp2['tandem_reserve_value'] = temp2['tandem_reserve_passes'] * seasonFees['monthly'];
          temp2['total_value'] += temp2['tandem_reserve_value'];

          totalTemp['tandem_reserve_passes'] += temp2['tandem_reserve_passes'];
          totalTemp['tandem_reserve_rate'] += seasonFees['monthly'];
          totalTemp['tandem_reserve_value'] += temp2['tandem_reserve_value'];
          totalTemp['total_passes'] += temp2['tandem_reserve_passes'];
          totalTemp['total_value'] += temp2['tandem_reserve_value'];

          temp2['tandem_reserve_value'] = helper.formatMoney(temp2['tandem_reserve_value']);
        }
        if(temp2['motorcycle_passes']) {
          temp2['motorcycle_rate'] = helper.formatMoney(seasonFees['monthly']);
          temp2['motorcycle_value'] = temp2['motorcycle_passes'] * seasonFees['monthly'];
          temp2['total_value'] += temp2['motorcycle_value'];

          totalTemp['motorcycle_passes'] += temp2['motorcycle_passes'];
          totalTemp['motorcycle_rate'] += seasonFees['monthly'];
          totalTemp['motorcycle_value'] += temp2['motorcycle_value'];
          totalTemp['total_passes'] += temp2['motorcycle_passes'];
          totalTemp['total_value'] += temp2['motorcycle_value'];

          temp2['motorcycle_value'] = helper.formatMoney(temp2['motorcycle_value']);
        }
        temp2['total_value'] = helper.formatMoney(temp2['total_value']);

        temp.push(temp2);
      }

      let groupkey = 'parkinglicense';
      let typeKey = 'customer';
      
      let existingLeaseGroup = [{[groupkey]:'', [typeKey]: 'EXISTING'}, {}];
      let newLeaseGroup = [{[groupkey]:'',[typeKey]: 'NEW APPLICATION'}, {}];
      let reinstatedLeaseGroup = [{[groupkey]:'',[typeKey]: 'REINSTATED'}, {}];
      let reactivatedLeaseGroup = [{[groupkey]:'',[typeKey]: 'REACTIVATED'}, {}];
      let terminatedLeaseGroup = [{[groupkey]:'',[typeKey]: 'TERMINATED'}, {}];
      let stopbillLeaseGroup = [{[groupkey]:'',[typeKey]: 'STOPPED BILLING'}, {}];
      let productUpDowngradeLeaseGroup = [{[groupkey]:'', [typeKey]: 'PRODUCT UPGRADE/DOWNGRADE'}, {}];
      for(let lease of temp) {
        if(lease['status'] === 'Terminated') {
          terminatedLeaseGroup.push(lease);
        } else if(lease['status'] === 'Stop Bill') {
          stopbillLeaseGroup.push(lease);
        } else if(lease['status'] === 'Active') {
          if(lease['type'] === 'ProductChange' || lease['type'] === 'PaymentPlanChange') {
            // TODO kw1 handle reactivate or reinstated
            productUpDowngradeLeaseGroup.push(lease);
            continue;
          }

          if(moment().startOf('month') < moment(lease['commencementDate'])) {
            newLeaseGroup.push(lease);
          } else {
            existingLeaseGroup.push(lease);
          }
        }
      }
      if(existingLeaseGroup.length > 2) {
        existingLeaseGroup.push({});
      }
      if(newLeaseGroup.length > 2) {
        newLeaseGroup.push({});
      }
      if(reinstatedLeaseGroup.length > 2) {
        reinstatedLeaseGroup.push({});
      }
      if(reactivatedLeaseGroup.length > 2) {
        reactivatedLeaseGroup.push({});
      }
      if(terminatedLeaseGroup.length > 2) {
        terminatedLeaseGroup.push({});
      }
      if(stopbillLeaseGroup.length > 2) {
        stopbillLeaseGroup.push({});
      }
      if(productUpDowngradeLeaseGroup.length > 2) {
        productUpDowngradeLeaseGroup.push({});
      }
      existingLeaseGroup.push({[groupkey]:'(A)', [typeKey]: 'EXISTING - TOTAL'}, {});
      newLeaseGroup.push({[groupkey]:'(B)',[typeKey]: 'NEW APPLICATION - TOTAL'}, {});
      reinstatedLeaseGroup.push({[groupkey]:'(C)',[typeKey]: 'REINSTATED - TOTAL'}, {});
      reactivatedLeaseGroup.push({[groupkey]:'(D)',[typeKey]: 'REACTIVATED - TOTAL'}, {});
      terminatedLeaseGroup.push({[groupkey]:'(E)',[typeKey]: 'TERMINATED - TOTAL'}, {});
      stopbillLeaseGroup.push({[groupkey]:'(F)',[typeKey]: 'STOPPED BILLING - TOTAL'}, {});
      productUpDowngradeLeaseGroup.push({[groupkey]:'(G)',[typeKey]: 'PRODUCT UPGRADE/DOWNGRADE - TOTAL'}, {});

      let temp3 = existingLeaseGroup.concat(newLeaseGroup, reinstatedLeaseGroup, reactivatedLeaseGroup, terminatedLeaseGroup, stopbillLeaseGroup, productUpDowngradeLeaseGroup);
      totalTemp[typeKey] = 'GRAND TOTAL (A) + (B) + (C) + (D) + (E) + (F) + (G)';
      temp3.push(totalTemp);

      temp3.forEach(k => {
        for(let key in k) {
          if(key.includes('_passes')) {
            k[key] = k[key] === 0 ? '' : k[key];
          }
          if(key.includes('_rate')) {
            if(k[key] === 0 || k[key] === '0.00') {
              k[key] = '';
            } else if(!typeof k[key] !== 'string') {
              k[key] = helper.formatMoney(k[key]);
            }
          }
          if(key.includes('_value')) {
            if(k[key] === 0 || k[key] === '0.00') {
              k[key] = '';
            } else if(!typeof k[key] !== 'string') {
              k[key] = helper.formatMoney(k[key]);
            }
          }
        }
      });

      this.$refs['pageTable'].setTableData(temp3);
      this.showExportCSV = true;
    },

    getUrl(licenseID) {
      let url = helper.SERVER_URL + '/api2';
      if(licenseID) {
        url += '/licenses/' + licenseID;
      }
      url += '/unpaidbills/';

      return url;
    },

    onFilterCarparkChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageReport = null);
      this.loadSeason();
    },
    onFilterDateChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageReport = null);
      this.loadLeaseActive();
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'paymethodID') {
        let paymentMethod = formData[formParameter.key];
        if(paymentMethod === this.paymentMethodIDGiro) {
          // giro
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = false;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
        } else if(paymentMethod === this.paymentMethodIDCheque) {
          // cheque
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = false;
        } else { 
          // cash?
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
        }
      } else if(formParameter.key === 'staffID') {
        let staff = helper.inputSelectFindOption(this.PAYMENT_PARAM_MAP['staffID'], formData['staffID'])
        formData['staffNo'] = staff['personnelCode'];
      }
    },
    onCSVButtonClick() {
      let startDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateStart);
      let endDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateEnd);
      printCSV('#jt-table', `Report Customer Movement ${startDate} - ${endDate}`);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Report/PageReportCustomerMovement.vue